/* eslint-disable header/header */
export var name = "msal";
export var version = "1.4.17";
//# sourceMappingURL=packageMetadata.js.map


//////////////////
// WEBPACK FOOTER
// ./~/msal/lib-es6/packageMetadata.js
// module id = 88
// module chunks = 0